/**
 * @generated SignedSource<<940bf05508cc53b494bab4274c97dbad>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type PromotionProblemEventDeleteInput = {
  promotionId: string;
};
export type PromotionId_promotionProblemEventDeleteMutation$variables = {
  input: PromotionProblemEventDeleteInput;
};
export type PromotionId_promotionProblemEventDeleteMutation$data = {
  readonly promotionProblemEventDelete: {
    readonly __typename: "PromotionProblemEvent";
  };
};
export type PromotionId_promotionProblemEventDeleteMutation = {
  response: PromotionId_promotionProblemEventDeleteMutation$data;
  variables: PromotionId_promotionProblemEventDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PromotionProblemEvent",
    "kind": "LinkedField",
    "name": "promotionProblemEventDelete",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PromotionId_promotionProblemEventDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PromotionId_promotionProblemEventDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "26e4192b0cb1fc58c169182035314bf1",
    "id": null,
    "metadata": {},
    "name": "PromotionId_promotionProblemEventDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation PromotionId_promotionProblemEventDeleteMutation(\n  $input: PromotionProblemEventDeleteInput!\n) {\n  promotionProblemEventDelete(input: $input) {\n    __typename\n  }\n}\n"
  }
};
})();

(node as any).hash = "6055e3d8d18496fdd4a05e51b89c4387";

export default node;
